var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoading)?_c(_vm.componentName,{tag:"component"}):_c('div',{staticClass:"xs-12 flex xs-center p4"},[_c('j-spinner')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }